(function() {
  'use strict';

  console.log('=== [Tracking Script] PAGE LOAD ===');

  const urlParams = new URLSearchParams(window.location.search);
  const campaignId = urlParams.get('campaign_id') || '';
  const adsetId = urlParams.get('adset_id') || '';
  const adId = urlParams.get('ad_id') || '';

  const hasUrlParams = !!(campaignId || adsetId || adId);
  console.log('[Tracking Script] URL parameters present:', hasUrlParams);
  if (!hasUrlParams) {
    console.log('[Tracking Script] ℹ️ No tracking params in URL');
    console.log('=== [Tracking Script] PAGE LOAD END ===\n');
    return;
  }

  const attributes = {};
  if (campaignId) attributes['campaign_id'] = campaignId;
  if (adsetId) attributes['adset_id'] = adsetId;
  if (adId) attributes['ad_id'] = adId;

  console.log('[Tracking Script] URL params:', attributes);

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({ attributes: attributes })
  })
    .then((response) => response.json())
    .then((data) => {
      console.log('[Tracking Script] ✅ Note attributes salvati:', data.attributes);
    })
    .catch((error) => {
      console.error('[Tracking Script] ❌ Errore salvataggio note attributes:', error);
    })
    .finally(() => {
      console.log('=== [Tracking Script] PAGE LOAD END ===\n');
    });
})();
